import React from 'react'
import { Link } from 'react-router-dom'
import { industries } from './industriesData'
import './IndustriesCardStack.css'

const base = process.env.PUBLIC_URL || ''

function TagLine({ text }) {
    const parts = text.split('|').map((s) => s.trim())
    return (
        <p className="td-industry-rows__tags">
            {parts.map((tag, i) => (
                <React.Fragment key={`${tag}-${i}`}>
                    {i > 0 && (
                        <span className="td-industry-rows__tag-sep" aria-hidden="true">
                            |
                        </span>
                    )}
                    <span className="td-industry-rows__tag">{tag}</span>
                </React.Fragment>
            ))}
        </p>
    )
}

function IndustriesCardStack() {
    return (
        <section className="td-industry-rows td-section rts-section-gap">
            <div className="container position-relative">
                <header className="td-industry-rows__header text-center">
                    <p className="td-industry-rows__eyebrow">Who we serve</p>
                    <h2 className="td-industry-rows__h2">Industries &amp; capabilities</h2>
                    <p className="td-industry-rows__lede">
                        Deep expertise across regulated and fast-moving sectors — security, operations, and content
                        that earns attention.
                    </p>
                    <div className="td-industry-rows__rule mx-auto" aria-hidden="true" />
                </header>

                <div className="td-industry-rows__list">
                    {industries.map((item) => (
                        <article key={item.num} className="td-industry-rows__row">
                            <div className="td-industry-rows__num" aria-hidden="true">
                                {item.num}
                            </div>
                            <div className="td-industry-rows__media">
                                <img
                                    src={`${base}${item.image}`}
                                    alt=""
                                    loading="lazy"
                                    decoding="async"
                                />
                            </div>
                            <div className="td-industry-rows__content">
                                <h3 className="td-industry-rows__title">{item.title}</h3>
                                <TagLine text={item.tags} />
                                <div className="td-industry-rows__body">
                                    {item.paras.map((p, i) => (
                                        <p key={i}>{p}</p>
                                    ))}
                                </div>
                            </div>
                            <div className="td-industry-rows__action">
                                <Link
                                    to={item.to}
                                    className="td-industry-rows__circle"
                                    aria-label={item.cta}
                                >
                                    <span className="td-industry-rows__circle-icon" aria-hidden="true">
                                        ↗
                                    </span>
                                </Link>
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default IndustriesCardStack
